export interface IModuleTaskI18n {
	readonly title: string;
	readonly locale: string;
	readonly category: string;
	readonly description: string;
}

export class ModuleTaskI18n implements IModuleTaskI18n {
	private _title: string;
	private _locale: string;
	private _category: string;
	private _description: string;

	constructor(
		title: string,
		locale: string,
		category: string,
		description: string
	) {
		this._title = title;
		this._locale = locale;
		this._category = category;
		this._description = description;
	}

	public get title(): string {
		return this._title;
	}

	public get locale(): string {
		return this._locale;
	}

	public get category(): string {
		return this._category;
	}

	public get description(): string {
		return this._description;
	}
}
